import { oz } from '@vy/utils';

export const BADGE_OPTIONS = Object.freeze({
  Connected: 'Connected',
  NotSupported: 'NotSupported',
});

export const BadgeOptionSchema = oz.nativeEnum(BADGE_OPTIONS).openapi('badgeOption');

export type BadgeOption = oz.infer<typeof BadgeOptionSchema>;
